<template>
    <div class="login-reg">
      <!-- -style="margin-top: 110px;" -->
      <van-image round width="110px" height="110px"
                 src="https://yibaoobj.oss-cn-shanghai.aliyuncs.com/prod/h5/yibao/002-logo.png"  />

      <div class="content">
          <div class="login-txt">验证码登录</div>


          <van-field class="van-field" style="margin-top: 20px;" v-model="phone" left-icon="https://yibaoobj.oss-cn-shanghai.aliyuncs.com/prod/h5/yibao/icon-phone.png"
                     placeholder="请输入手机号" type="tel" />
          <van-field class="van-field"  v-model="password" left-icon="https://yibaoobj.oss-cn-shanghai.aliyuncs.com/prod/h5/yibao/icon-lock.png"
                     placeholder="请输入短信验证码" type="digit" >
            <template #right-icon>
                <span style="color: #ebedf0;font-size: 14px;font-weight: 500;">|</span>
                <span v-show="!start" style="color: #3894FF;margin-left: 10px;" @click="startCountDown">获取验证码</span>
                 <van-count-down v-show="start" ref="countDown" :time="time" format="ss秒后重新获取" @finish="finished"/>

            </template>
          </van-field>
          <van-button class="van-field" round type="info" @click="gotoLogin" style="margin-top: 20px;">登录</van-button>
          <div class="van-field" style="color: #879EA3;padding-bottom: 40px;margin-top: 20px;font-size: 12px;text-align: center;">
            未注册的手机号验证后将自动创建新账号
          </div>
        <!-- <van-field v-model="password" :border="false" clearable placeholder="请输入密码" type="password"
                      style="background-color: #FAFAFA; margin-bottom: 15px;"/>
           <div style="display: flex; justify-content: space-between; font-size: 14px; margin-bottom: 40px; color: #666666;">
               <div>暂无账号，<span style="color: #066BEE;" @click="gotoRegister">点击注册</span></div>
               <div @click="forgotPassword">忘记密码</div>
           </div>

           <van-button type="info" @click="gotoLogin" style="margin-bottom: 50px;">登录</van-button>-->
       </div>


    </div>
</template>

<script>

    import Vue from 'vue';
    import {Field, Button, Notify, Dialog,Icon,CountDown} from 'vant';
    import VueCookies from 'js-cookie'
    import {urlEncode} from "../../utils/commonUtils";

    Vue.use(Field).use(Button).use(Notify).use(Icon).use(CountDown).use(VueCookies);
    export default {
        name: "Login",
        data() {
            return {
                phone: '',
                password: '',
                openId: this.$route.query.openId || VueCookies.get('openId') || localStorage.getItem("openId") || '',
                unionId: this.$route.query.unionId || VueCookies.get('unionId') || localStorage.getItem("unionId")|| '',
                headImgUrl: this.$route.query.headImgUrl || VueCookies.get('headImgUrl') || localStorage.getItem("headImgUrl") || '',
                nickname: this.$route.query.nickname || VueCookies.get('nickname')  || localStorage.getItem("nickname")|| '',
                currentUrl : VueCookies.get('currentUrl'),
                shareUserId:'',
                type: VueCookies.get('type')|| localStorage.getItem('type'),
                start: false,
                time: 60 * 1000,
            }
        },
      created() {
        console.log(this.openId,">>");
        console.log(sessionStorage.getItem("openId"),">>>")
      },
      methods: {
        startCountDown() {
          if (this.phone.length === 0) {
            Notify({
              message: '请输入手机号',
              duration: 2500,
              background: '#F76C6C'
            });
            return;
          }

          this.$axios.get("/user/verifyCode", {params: {phoneNum: this.phone, type: 'register-login'}}).then(res => {
            if (res.code == 200) {
              this.start = true;
              this.$refs.countDown.start();
            }
          })
        },
        finished() {
          this.$refs.countDown.reset();
          this.start = false;
        },
        gotoRegister() {
          this.$router.push('/register');
        },
        forgotPassword() {
          this.$router.push('/forgotPassword');
        },
        gotoLogin() {
          if (this.phone.length === 0) {
            Notify({
              message: '请输入手机号',
              duration: 2500,
              background: '#F76C6C'
            });
            return;
          }
          if (this.password.length === 0) {
            Notify({
              message: '请输入短信验证码',
              duration: 2500,
              background: '#F76C6C'
            })
            return;
          }

          if (this.currentUrl) {
            this.$axios.get("/jump/shareId", {params: {currentUrl: this.currentUrl}}).then(res => {
              if (res.data) {
                this.shareUserId = res.data
              }
              this.toLogin()
            });
          } else {
            if (this.$route.query.shareId) {
              this.shareUserId = this.$route.query.shareId
            }
            this.toLogin()
          }


        },
        toLogin() {
          let params = {
            userPhone: this.phone,
            validCode: this.password,
            shareUserId: this.shareUserId,
            type: this.type,
            openId: this.openId || localStorage.getItem("openId"),
            unionId: this.unionId || localStorage.getItem("unionId"),
            nickname: this.nickname || localStorage.getItem("nickname"),
            headImgUrl: this.headImgUrl || localStorage.getItem("headImgUrl"),
            verifyType: 'register-login'
          }
          this.$store.dispatch('Login', params).then((res) => {
            if (res.code === 324) {
              //如果该账号和数据库中已存在的unionId不一样时，证明微信更换，寻求用户是否替换微信，或者用原有微信登录
              Dialog.alert({
                message: '该账号所绑定微信账号与当前登录账号不一致，是否要切换账号绑定微信账号',
                title: '系统提示',
                confirmButtonText: '切换',
                cancelButtonText: '取消'
              }).then(() => {
                //更新账号绑定微信账号
                window.axios.post("/user/updateUnionId", params).then(res => {
                  if (res.code === 200) {
                    Dialog.alert({
                      message: '切换成功',
                      title: '系统提示'
                    })
                  }
                }).catch(error => {
                  //reject(error)
                })
              });
            }
            if (res.code === 200) {

              if (this.type != 3) {
                //add by cpgu 2023/05/29 添加以下if begin
                if(localStorage.getItem("location_host")){
                  //window.location.href = "https://" + localStorage.getItem("location_host") + "/custProductDetail?" + localStorage.getItem("link_params")
                  this.$router.push({path: '/custProductDetail?'+localStorage.getItem("link_params")})
                  localStorage.removeItem("location_host")
                  localStorage.removeItem("link_params")
                }else{
                  this.$router.push('/')

                }

              } else {
                this.$router.push('/Ahome')
              }
              /*const url = decodeURI(this.$route.query.redirectUrl)
              if (url) {
                  this.$router.push(url)
              } else {
                  this.$router.push('/')
              }*/
            }
          })
        },


      }
    }
</script>

<style scoped>
.login-reg{
  padding: 0 50px;
  display: flex;
  flex-direction: column;
  background-image: url("https://yibaoobj.oss-cn-shanghai.aliyuncs.com/test/20230126/068a846294f4d8c87e2716d29eba06ef.png");
  height: 100vh;
  background-position: center center;
  background-size: cover;
  align-items: center;
  justify-content: center;
}
.content{
  margin-top: 50px;
  background: #FFFFFF;
  border-radius: 10px;
  width: 90vw;
}
.content{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.login-txt{
  color: #3894FF;
  font-size: 20px;
  font-weight: bold;
  padding-top: 30px;
/*  text-underline-offset: 8px;
  text-decoration: underline;
  text-decoration-color: #0070C0;*/
  position: relative;
}
.login-txt:after{
  position: absolute;
  bottom: -3px;
  left: 0;
  height: 2px;
  content: "";
  background: #0070C0;
  width: 100%;
}
.van-field{
  width: 90%;
}
.van-field /deep/.van-field__left-icon{
  top: 3px ;
  position: relative;
}
</style>
